import InfiniteScroll from "react-infinite-scroll-component";
import { t } from "@/i18n-js/instance";
import { useNearMeFilter } from "@/react/components/shared/MemberFilters/SharedFilters/NearMe/useNearMeFilter";
import { LoaderRow } from "@circle-react/components/shared/LoaderRow";
import { Typography } from "@circle-react-uikit/Typography";
import type { UseSelectMembersInfiniteQuery } from "../hooks/useSelectMembersInfiniteQuery";
import { CommunityMember } from "./CommunityMemberWithConnection/CommunityMember";

interface ListViewProps {
  memberDataParams: UseSelectMembersInfiniteQuery;
  shouldShowHiddenMemberTooltip: boolean;
}

export const ListView = ({
  memberDataParams,
  shouldShowHiddenMemberTooltip,
}: ListViewProps) => {
  const { isActiveQuery, dataLength, fetchNextPage, hasNextPage, members } =
    memberDataParams;

  const { nearMeFilter, isNearMeActive } = useNearMeFilter();

  return (
    <div>
      {isActiveQuery && (
        <div
          className="member-directory-members__count"
          data-testid="members-directory-count"
        >
          {isNearMeActive && (
            <>
              <Typography.LabelSm weight="medium">
                {t("member_directory.near_me.title", {
                  count: dataLength,
                })}
              </Typography.LabelSm>
              <Typography.BodyXs>{nearMeFilter?.value?.name}</Typography.BodyXs>
            </>
          )}
        </div>
      )}
      <InfiniteScroll
        style={{ overflow: "initial" }}
        scrollThreshold={0.5}
        next={fetchNextPage}
        hasMore={!!hasNextPage}
        loader={<LoaderRow />}
        dataLength={members.length}
        scrollableTarget="panel"
      >
        <ul
          className="flex list-none flex-col gap-y-4"
          data-testid="directory_members_list"
        >
          {members.map((communityMember, index) => (
            <CommunityMember
              communityMember={communityMember}
              key={communityMember.id}
              shouldShowHiddenMemberTooltip={shouldShowHiddenMemberTooltip}
              isLastItem={index === members.length - 1}
            />
          ))}
        </ul>
      </InfiniteScroll>
    </div>
  );
};
